"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _curry = _interopRequireDefault(require("curry"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _camelCase2 = _interopRequireDefault(require("lodash/camelCase"));
var camelCase = (0, _curry.default)(function (data) {
  if (!data) return null;
  if (Array.isArray(data)) {
    return (0, _camelCase2.default)(data.reduce(function (str, item) {
      return !!item ? "".concat(str, "-").concat(item) : str;
    }, ''));
  }
  if ((0, _isString.default)(data)) {
    return (0, _camelCase2.default)(data);
  }
  return null;
});
var _default = camelCase;
exports.default = _default;